<!-- #72 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        DateWise summary
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="_headers"
      :items="summarylist"
      :options.sync="options"
      :server-items-length="total"
      :loading="summarylistLoader"
      class="elevation-1 custom-icon-size mt-7"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <v-form>
          <v-row class="custom-row pl-5 pr-5">
            <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
              <v-autocomplete
                label="Vendor Name"
                :items="vendors"
                v-model="selectedVendor"
                item-text="vendor_name"
                item-value="id"
                hide-details
                outlined
                @focus="getvendorList"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                label="Employee Role"
                :items="roles"
                v-model="employee_role"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(from_date)"
                    label="From Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    outlined
                    @click:clear="clearDateInput('this.from_date')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="from_date"
                  @input="dateMenu = false"
                  :max="getEndDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3">
              <v-menu
                v-model="dateMenuTo"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(to_date)"
                    label="To Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    outlined
                    @click:clear="clearDateInput('this.to_date')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="to_date"
                  @input="dateMenuTo = false"
                  :max="getEndDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              class="text-end pr-4 mb-2"
              :sm="userCategory.user_category == 3 ? '12' : '3'"
            >
              <v-btn class="mt-0 success" color="primary" @click="searchAll"
                >Search</v-btn
              >
              <v-btn color="white" class="mt-0 ml-4" @click="allClear"
                >Clear</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
        <v-divider class="mb-5"></v-divider>
      </template>
      <template v-slot:[`item.tracking_id`]="{ item }">
        <span v-if="$route.query.type == 'rsa'">{{
          item.rsa_tracking_id
        }}</span>
        <span v-else>{{ item.carrier_tracking_id }}</span>
      </template>
    </v-data-table>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    _headers() {
      return this.headers.filter((i) => {
        if (this.userCategory.user_category == 5) {
          if (i.value !== "total_ot_cost" && i.value !== "total_cost") {
            return true;
          }
        } else {
          return true;
        }
      });
    },
    ...mapGetters(["userRole", "userCategory"]),
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
  },
  data: () => ({
    dateMenu: false,
    from_date: "",
    to_date: "",
    dateMenuTo: false,
    roles: ["WHA", "RTO"],

    headers: [
      {
        text: "Date",
        value: "date",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Vendor Name",
        value: "vendor_name",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Employee Role",
        value: "employee_role",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Total Extra hours",
        value: "total_extra_hours",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Total OT Cost(In AED)",
        value: "total_ot_cost",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Total Hours",
        value: "total_hours",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Total Number of Employee",
        value: "no_of_employee",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Total Cost(In AED)",
        value: "total_cost",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    options: {},
    total: 0,
    summarylistLoader: false,
    filtersArr: [],
    summarylist: [],
    client_name: null,
    carrier: null,
    country: null,
    vendors: [],
    vendorLoader: false,
    selectedVendor: null,
    employee_role: "",
  }),

  watch: {
    options: {
      handler() {
        this.from_date = this.$route.query.from_date;
        this.to_date = this.$route.query.to_date;
        this.selectedVendor = this.$route.query.vendor_id;
        (this.employee_role = this.$route.query.employee_role),
          this.fetchsummarylist();
      },
      deep: true,
    },
  },
  async created() {
    // await this.getvendorList();
  },
  methods: {
    ...mapActions(["summaryDetails", "getvendorDropdown"]),

    getvendorList() {
      if (
        this.vendors.length === 0 &&
        this.$store.getters.user.user_category === 3
      ) {
        this.vendorLoader = true;

        this.getvendorDropdown()
          .then((res) => {
            this.vendorLoader = false;
            this.vendors = res.data;
            const queryVendorId = this.$route.query.vendor_id;
            if (queryVendorId) {
              this.selectedVendor = this.vendors.find(
                (vendor) => vendor.id === Number(queryVendorId)
              );
              this.selectedVendor = this.selectedVendor.id;
            }
          })
          .catch(() => {
            this.vendorLoader = false;
          });
      }
    },
    clearInput(val) {
      if (val) {
        val = null;
      }
    },
    clearDateInput(type) {
      if (type == "this.to_date") {
        this.to_date = "";
      } else {
        this.from_date = "";
      }
    },
    allFilters() {
      this.loader = true;
      let obj = {
        from_date: this.from_date,
        to_date: this.to_date,
        employee_role: this.employee_role,
        vendor_id: this.selectedVendor,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.summarylistLoader = true;

      this.options.page = 1;
      this.$route.query.employee_role = this.employee_role;
      this.$route.query.vendor_id = this.selectedVendor;

      this.$route.query.from_date = this.from_date;
      this.$route.query.to_date = this.to_date;
      //   this.$route.query.vendor_id = this.selectedVendor;
      this.allFilters();

      this.summaryDetails({
        ...this.options,
        ...this.filtersArr,
        ...this.$route.query,
      })
        .then((res) => {
          this.summarylistLoader = false;
          this.summarylist = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.summarylistLoader = false;
        });
    },
    clear() {
      this.to_date = this.$route.query.to_date;
      this.employee_role = this.$route.query.employee_role;
      this.from_date = this.$route.query.from_date;

      const queryVendorId = this.$route.query.vendor_id;
      if (queryVendorId) {
        this.selectedVendor = this.vendors.find(
          (vendor) => vendor.id === Number(queryVendorId)
        );

        this.selectedVendor = this.selectedVendor.id;
      }
    },
    async allClear() {
      await this.clear();
      this.filtersArr = {};
      await this.fetchsummarylist();
    },

    fetchsummarylist() {
      this.summarylist = [];
      this.summarylistLoader = true;
      this.summaryDetails({
        ...this.options,
        ...this.filtersArr,
        ...this.$route.query,
      })
        .then(async (res) => {
          this.summarylistLoader = false;
          this.summarylist = res.data.records;
          this.total = res.data.total;
          await this.getvendorList();
        })
        .catch(() => {
          this.summarylistLoader = false;
        });
    },
  },
};
</script>
